import { createSelector } from 'reselect';
import { getRouterBaseUrl } from '../app/reducers/configuration';

/**
 * Matches start of an URL to `routerBaseUrl` and a GUID.
 *
 * It's used for testing whether an URL has the server or the application format.
 */
export const getRouterBasePathRegex = createSelector(
    getRouterBaseUrl,
    (routerBaseUrl) => new RegExp(`^${routerBaseUrl}`)
);
